import React, { useState } from 'react'
import { Box, Tabs, Tab, Typography, Container, Paper } from '@mui/material'
import Base from '../Components/Base'
import UsersManagement from '../Components/Admin/UsersManagement'
import GenresManagement from '../Components/Admin/GenresManagement'
import AuditLogs from '../Components/Admin/AuditLogs'
import SystemHealth from '../Components/Admin/SystemHealth'

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `admin-tab-${index}`,
    'aria-controls': `admin-tabpanel-${index}`,
  }
}

const AdminDashboard = () => {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Base>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="700">
          Espace Administration
        </Typography>
        
        <Paper elevation={0} sx={{ width: '100%', border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
              value={value} 
              onChange={handleChange} 
              aria-label="admin dashboard tabs"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Utilisateurs" {...a11yProps(0)} />
              <Tab label="Genres" {...a11yProps(1)} />
              <Tab label="Journaux d'Audit" {...a11yProps(2)} />
              <Tab label="Santé Système" {...a11yProps(3)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <UsersManagement />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <GenresManagement />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <AuditLogs />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <SystemHealth />
          </CustomTabPanel>
        </Paper>
      </Container>
    </Base>
  )
}

export default AdminDashboard
